export const calendar ={
    type:"calendar",
    name:"Calendar",
    label:"Calendar"
} 